import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ReporteConteoGuiaForm } from "./form";
type Entity = models.ConteoGuiasParams;
const resource = resources.Guia;

interface State {
    value: Promise<Entity> | Entity;
}

export class ReporteConteoGuiaEditComp extends React.PureComponent<{}, State> {
    constructor(state: State) {
        super(state);
        this.state = { value: this.getValue() };
    }

    async getValue(): Promise<Entity> {
        const now = new Date();
        return {
            FechaInicio: now,
            FechaFinal: now
        };
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerar = async () => {
        const value = await this.state.value;
        var reporte = await resource.ReporteConteo(value);
        kea.download(kea.base64ToBlob(reporte, 'application/pdf'), "Reporte conteo de guias.pdf");
    }

    render() {
        return <ReporteConteoGuiaForm value={this.state.value} onChange={this.onChange} onGenerar={this.onGenerar} />;
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteconteoguia/index.tsx